import AlertBar from './alert-bar-view';

export default AlertBar;
